/* jslint esversion: 6 */
import ManagementHome from '../views/home/index.vue';

export default [
  {
    path: '/browser',
    component: ManagementHome
  }
];



// WEBPACK FOOTER //
// ./src/router/defaultRouter.js